export const surveryQuestions = [
  {
    question: 'How could the new Sales Rep setup report be more helpful?',
    response: '',
  },
  {
    question: 'What else do you wish you could do on behalf of sales reps?',
    response: '',
  },
  {
    question: 'Any other feedback?',
    response: '',
  },
]
